<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zTVLmR/tc-custom/9781459262102.jpg?1740459907893" alt="This image is the cover for the book Sheikh's Seduction"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sheikh's Seduction
      </h1>
      <p class="bookDescription body article font2">
        <b><i>Who was seducing whom?</i></b><br/><br/>With her family's future happiness in Tareq al-Khaima's all-controlling hands, Sarah Hillyard was persuaded to become the sheikh's traveling companion for a year. She remembered his gentleness toward her as a young girl, but now she suspected Tareq's scheme was a calculated means of getting closer to the beautiful woman she had becomewith no promise of commitment on his part.<br/><br/>Tareq claimed to have lost the capacity to love and he was so totally self-contained, so <i>frustratingly</i> untouchable that Sarah surprised herself by wanting to find out how he would react if she turned the tablesand set about seducing <i>him!</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emma Darcy
      </h2>
      
      <p class="authorDescription body article">Initially a French/English teacher, Emma Darcy changed careers to computer programming before the happy demands of marriage and motherhood. Very much a people person, and always interested in relationships, she finds the world of romance fiction a thrilling one and the challenge of creating her own cast of characters very addictive.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7df30de4